enum AwsRumRealm {
    EU_WEST_1 = 'eu-west-1',
    US_EAST_1 = 'us-east-1',
    US_WEST_2 = 'us-west-2'
}
export default AwsRumRealm;
